import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { AdminLayout } from '../layout/AdminLayout';
import { LoginPage } from '../screens/LoginPage';
import { DashboardPage } from '../screens/DashboardPage';
import { AgentsPage } from '../screens/AgentsPage';
import { UsersPage } from '../screens/UsersPage';
import { BotUsersPage } from '../screens/BotUsersPage';
import { ProvidersPage } from '../screens/ProvidersPage';
import { PartnersPage } from '../screens/PartnersPage';
import { SubscriptionsPage } from '../screens/SubscriptionsPage';
import { CuratedToursPage } from '../screens/CuratedToursPage';
import { PartnerAnalyticsPage } from '../screens/PartnerAnalyticsPage';
import { SearchHistoryPage } from '../screens/SearchHistoryPage';
import { BroadcastPage } from '../screens/BroadcastPage';
import { AdminsPage } from '../screens/AdminsPage';
import { AiUsagePage } from '../screens/AiUsagePage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="ai-usage" element={<AiUsagePage />} />
        <Route path="agents" element={<AgentsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="bot-users" element={<BotUsersPage />} />
        <Route path="providers" element={<ProvidersPage />} />
        <Route path="subscriptions" element={<SubscriptionsPage />} />
        <Route path="partners" element={<PartnersPage />} />
        <Route path="curated-tours" element={<CuratedToursPage />} />
        <Route path="partner-analytics" element={<PartnerAnalyticsPage />} />
        <Route path="search-history" element={<SearchHistoryPage />} />
        <Route path="broadcast" element={<BroadcastPage />} />
        <Route path="admins" element={<AdminsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

